import { AccordionDetails, AccordionSummary } from "@mui/material";
import { AccordionRowHeader, HealthRecordsAccordion as StyledAccordion } from "./HealthRecords.style";

import { ChevronRightIcon } from "../../../components/Icons";
import React from "react";

type Props = {
  id: string;
  icon: JSX.Element;
  label: string;
  expanded: boolean;
  onToggle: (id: string) => void;
  children: React.ReactNode;
};

const HealthRecordsAccordion = (props: Props) => {
  const { id, icon, label, expanded, onToggle, children } = props;

  return (
    <StyledAccordion expanded={expanded} onChange={() => onToggle(id)}>
      <AccordionSummary
        expandIcon={<ChevronRightIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <AccordionRowHeader>
          {icon}
          <p className="geograph-medium text-[14px] leading-[14px] text-light-black">
            {label}
          </p>
        </AccordionRowHeader>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default HealthRecordsAccordion;
